
import React from 'react'
import Styles from "./toggle.module.scss"

const Toggle = ({
    text,
    size = "default",
    checked,
    disabled,
    onChange,
    offstyle = "btn-danger",
    onstyle = "btn-success"
}) => {
    let displayStyle = checked ? onstyle : offstyle;

    return (
        <label>
            <span className={`${size} ${Styles?.switch_wrapper}`}>
                <input
                    type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    onChange={e => onChange(e)}
                />
                <span className={`${displayStyle} ${Styles.switch}`}>
                    <span className={Styles.switch_handle} />
                </span>
            </span>

        </label>
    )
}

export default Toggle